import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { UserStore } from '@stores/user.store';
import { map, take } from 'rxjs';
import { KeycloakService } from '@app/modules/auth/keycloak.service';

export const RoleAccessGuard = (allowedRoles: Array<string>, redirectPath?: string) => {
    return (
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) => {
        const kc = inject(KeycloakService);
        const user = inject(UserStore);
        const router = inject(Router);

        if (!kc.isLoggedIn) {
            return false;
        }

        return user.role$
            .pipe(
                take(1),
                map((role) => {
                    if (allowedRoles.includes(role)) {
                        return true;
                    }

                    if (redirectPath) {
                        return router.parseUrl(redirectPath);

                    }

                    return false;
                })
            )
    };
}
